import { render, staticRenderFns } from "./oui-cfhcouponquestion.vue?vue&type=template&id=44551306&scoped=true&"
import script from "./oui-cfhcouponquestion.vue?vue&type=script&lang=js&"
export * from "./oui-cfhcouponquestion.vue?vue&type=script&lang=js&"
import style0 from "./oui-cfhcouponquestion.vue?vue&type=style&index=0&id=44551306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44551306",
  null
  
)

export default component.exports